import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import isRequiredIf from '../../modules/react-conditional-required';
import FlightConnectionLine from '../flightConnectionLine/FlightConnectionLine';

import './FlightGridDetails.css';

var I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  flightNumber: PropTypes.number.isRequired,
  flightConnections: PropTypes.number.isRequired,
  throughFlights: PropTypes.number,
  elapsedFlightTime: PropTypes.string,
  toogleElapsedFlightTime: PropTypes.bool,
  hasAirportChange: PropTypes.bool.isRequired,
  flightGroup: PropTypes.arrayOf(PropTypes.object),
  departureFlight: PropTypes.shape({
    time: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    plusDays: PropTypes.number,
    airportSign: isRequiredIf(PropTypes.string, props => !props.hasEmpty)
  }),
  arrivalFlight: PropTypes.shape({
    time: isRequiredIf(PropTypes.string, props => !props.hasEmpty),
    plusDays: PropTypes.number,
    airportSign: isRequiredIf(PropTypes.string, props => !props.hasEmpty)
  }),
  openFlightDetails: PropTypes.func,
  className: PropTypes.string,
  isCompact: PropTypes.bool
};

const defaultProps = {
  isCompact: false,
  toogleElapsedFlightTime: false,
  elapsedFlightTime: ''
};

class FlightGridDetails extends React.Component {
  formatPlusDays() {
    const plusDays = this.props.arrivalFlight.plusDays;
    let formatPlusDays = '';
    if (plusDays && plusDays > 0) {
      formatPlusDays = `+${plusDays} ${I18n.translate('components.flightTime.day')}`;
      if (plusDays > 1) {
        formatPlusDays = `+${plusDays} ${I18n.translate('components.flightTime.days')}`;
      }
    }
    return formatPlusDays;
  }

  getFlightStopsLabel() {
    let message = this.getStopFlights();

    if (message === 0) {
      return I18n.translate('components.flightDetails.directFlight');
    }
    if (this.props.hasAirportChange) {
      message = `${message} ${I18n.translate('components.flightDetails.withAirportChange')}`;
    }

    return message;
  }

  getStopFlights() {
    let stopFlights = 0;
    stopFlights = this.props.flightConnections + this.props.throughFlights;

    if (stopFlights === 1) {
      stopFlights = `${stopFlights} ${I18n.translate('components.flightDetails.stopFlight')}`;
    } else if (stopFlights > 1) {
      stopFlights = `${stopFlights} ${I18n.translate('components.flightDetails.stopFlights')}`;
    }
    return stopFlights;
  }

  getElapsedFlightTime() {
    let elapsedFlightTime = '';
    if (this.props.elapsedFlightTime !== '' && this.props.elapsedFlightTime.length == 4) {
      elapsedFlightTime = `${this.props.elapsedFlightTime.substring(
        0,
        2
      )}h${this.props.elapsedFlightTime.substring(2, 4)}`;
    }

    return elapsedFlightTime;
  }

  renderWithToogle() {
    return (
      <div
        id={`FlightGridDetails-${this.props.id}`}
        className={`FlightGridDetailsContainer ${this.props.className || ''}`}>
        <Row>
          <Col xs={12} className={`totalTimeTextCol ${this.props.isCompact ? 'compact' : ''}`}>
            <ControlLabel
              className={`FlightGridDetailsContainer__elapsedFlightTime totalTimeText `}>
              {this.getElapsedFlightTime()}
            </ControlLabel>
          </Col>
        </Row>
        <Row>
          <Col
            md={4}
            xs={this.props.isCompact ? 5 : 4}
            className="FlightGridDetailsContainer__departureContainer">
            <Row>
              <Col xs={12}>
                <ControlLabel
                  className={`FlightGridDetailsContainer__departureContainer__departureTime departure timeWithToogle ${
                    this.props.isCompact ? 'compact' : ''
                  }`}>
                  {this.props.departureFlight.time}
                </ControlLabel>
                <ControlLabel
                  className={`FlightGridDetailsContainer__departureContainer__departureAirport departure airportSignWithToogle ${
                    this.props.isCompact ? 'compact' : ''
                  } `}>
                  {this.props.departureFlight.airportSign}
                </ControlLabel>
              </Col>
            </Row>
          </Col>
          <Col
            md={3}
            xs={this.props.isCompact ? 2 : 4}
            className={`FlightGridDetailsContainer__connectionContainer ${
              this.props.isCompact ? 'compact' : ''
            }`}>
            <Row className="FlightGridDetailsContainer__connectionContainer_connection">
              <Col
                xs={12}
                className="FlightGridDetailsContainer__connectionContainer__connectionLine lineCentralized">
                <FlightConnectionLine
                  flightGroup={[...this.props.flightGroup]}
                  isCompact={this.props.isCompact}
                />
              </Col>
            </Row>
          </Col>
          <Col
            md={5}
            xs={this.props.isCompact ? 5 : 4}
            className="FlightGridDetailsContainer__arrivalContainer">
            <Row>
              <Col xs={12}>
                <ControlLabel
                  className={`FlightGridDetailsContainer__arrivalContainer__arrivalTime arrival timeWithToogle ${
                    this.props.isCompact ? 'compact' : ''
                  } `}>
                  {this.props.arrivalFlight.time}
                </ControlLabel>
                <div className="FlightGridDetailsContainer__arrivalContainer__hourContainer">
                  <ControlLabel
                    className={`FlightGridDetailsContainer__arrivalContainer__arrivalAirport arrival airportSignWithToogle ${
                      this.props.isCompact ? 'compact' : ''
                    } `}>
                    {this.props.arrivalFlight.airportSign}
                  </ControlLabel>
                  <ControlLabel
                    className={`FlightGridDetailsContainer__arrivalContainer__plusDays arrival plusDays ${
                      this.props.isCompact ? 'compact' : ''
                    }`}>
                    {this.formatPlusDays()}
                  </ControlLabel>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="connectionTextCol">
            <ControlLabel
              className={[
                'connectionText FlightGridDetailsContainer__connectionContainer__flightConections',
                this.props.hasAirportChange ? 'airport-change' : ''
              ]}>
              {this.getFlightStopsLabel()}
            </ControlLabel>
          </Col>
        </Row>
        {this.props.openFlightDetails && (
          <Row>
            <Col xsHidden md={12} className="detailsTextCol">
              <ControlLabel
                id={`btnDetailsModalF-${this.props.flightNumber}`}
                onClick={this.props.openFlightDetails}
                className="connectionText btnDetailsModal FlightGridDetailsContainer__detailsContainer">
                <span>{I18n.translate('components.flightDetails.detailsBtn')}</span>
              </ControlLabel>
            </Col>
          </Row>
        )}
      </div>
    );
  }

  renderGrid() {
    return (
      <div
        id={`FlightGridDetails-${this.props.id}`}
        className={`FlightGridDetailsContainer ${this.props.className || ''}`}>
        <Row>
          <Col
            md={4}
            xs={this.props.isCompact ? 5 : 4}
            className="FlightGridDetailsContainer__departureContainer">
            <Row>
              <Col xs={12}>
                <ControlLabel
                  className={`FlightGridDetailsContainer__departureContainer__departureTime departure time ${
                    this.props.isCompact ? 'compact' : ''
                  } `}>
                  {this.props.departureFlight.time}
                </ControlLabel>
                <ControlLabel
                  className={`FlightGridDetailsContainer__departureContainer__departureAirport departure airportSign ${
                    this.props.isCompact ? 'compact' : ''
                  }`}>
                  {this.props.departureFlight.airportSign}
                </ControlLabel>
              </Col>
            </Row>
          </Col>
          <Col
            md={3}
            xs={this.props.isCompact ? 2 : 4}
            className={`FlightGridDetailsContainer__connectionContainer ${
              this.props.isCompact ? 'compact' : ''
            }`}>
            <Row className="FlightGridDetailsContainer__connectionContainer_connection">
              <Col
                xs={12}
                className="FlightGridDetailsContainer__connectionContainer__connectionLine lineCentralized">
                <FlightConnectionLine
                  flightGroup={[...this.props.flightGroup]}
                  isCompact={this.props.isCompact}
                />
              </Col>
            </Row>
          </Col>
          <Col
            md={5}
            xs={this.props.isCompact ? 5 : 4}
            className="FlightGridDetailsContainer__arrivalContainer">
            <Row>
              <Col xs={12}>
                <ControlLabel
                  className={`FlightGridDetailsContainer__arrivalContainer__arrivalTime arrival time ${
                    this.props.isCompact ? 'compact' : ''
                  } `}>
                  {this.props.arrivalFlight.time}
                </ControlLabel>
                <div className="FlightGridDetailsContainer__arrivalContainer__hourContainer">
                  <ControlLabel
                    className={`FlightGridDetailsContainer__arrivalContainer__arrivalAirport arrival airportSign ${
                      this.props.isCompact ? 'compact' : ''
                    }`}>
                    {this.props.arrivalFlight.airportSign}
                  </ControlLabel>
                  <ControlLabel
                    className={`FlightGridDetailsContainer__arrivalContainer__plusDays arrival plusDays ${
                      this.props.isCompact ? 'compact' : ''
                    }`}>
                    {this.formatPlusDays()}
                  </ControlLabel>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="connectionTextCol">
            <ControlLabel
              className={[
                'connectionText FlightGridDetailsContainer__connectionContainer__flightConections',
                this.props.hasAirportChange ? 'airport-change' : ''
              ]}>
              {this.getFlightStopsLabel()}
            </ControlLabel>
          </Col>
        </Row>
        {this.props.openFlightDetails && (
          <Row>
            <Col xsHidden md={12} className="detailsTextCol">
              <ControlLabel
                id={`btnDetailsModalF-${this.props.flightNumber}`}
                onClick={this.props.openFlightDetails}
                className="connectionText btnDetailsModal FlightGridDetailsContainer__detailsContainer">
                <span>{I18n.translate('components.flightDetails.detailsBtn')}</span>
              </ControlLabel>
            </Col>
          </Row>
        )}
      </div>
    );
  }

  render() {
    if (this.props.toogleElapsedFlightTime) {
      return this.renderWithToogle();
    } else {
      return this.renderGrid();
    }
  }
}
FlightGridDetails.propTypes = propTypes;
FlightGridDetails.defaultProps = defaultProps;

export default FlightGridDetails;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightGridDetails/FlightGridDetails.jsx